import { data } from "../data/value";
import { useEffect, useState } from "react";
import {
  MdArrowBack,
  MdArrowLeft,
  MdArrowRight,
  MdArrowRightAlt,
} from "react-icons/md";
import { IoDocumentOutline } from "react-icons/io5";
import InaugurationDate from "../components/Inagaration";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import { FaArrowRight, FaSearch } from "react-icons/fa";
import { IoEyeOutline } from "react-icons/io5";
import { ImCross } from "react-icons/im";
import { getLeads } from "../apis/leadApi";
import { useNavigate, useParams } from "react-router-dom";
import { assignToEmployees, getAllFranchise } from "../apis/franchise";
import { getAllEmployee } from "../apis/employeeApi";
import { getAllTeam } from "../apis/teamApis";

const timelineData = [
  { label: "Account ", type: "span" },
  { label: "Document ", type: "span" },
  { label: "interior ", type: "span" },
  { label: "Branding ", type: "span" },
  { label: "Purchase ", type: "span" },
  { label: "Pre-Inauguration ", type: "span" },
  { label: "Inauguration", type: "span" },
];

const payment = [
  { Date: "23/5/25", amount: "500", payment: "Gpay" },
  { Date: "22/2/22", amount: "1000", payment: "Phone Pay" },
];

const document = [
  { date: "25/8/24", doucmentType: "Agreement", document: "logo" },
  { date: "3/3/23", doucmentType: "Agreement", document: "logo" },
];

const inter = [{ date: "2/5/23", interWork: "baner set", document: "logo" }];

const brand = [{ date: "2/5/25", brandName: "Bakshanam", brandType: "chitra" }];

const purchase = [
  { date: "3/6/17", purchaseName: "Chitra", purchaceItem: "Milk" },
];

const inagration = [{ date: "4/6/16", workplace: "Vellore", itemUsed: "Milk" }];

const inagarationDate = [
  { date: "2/4/23", inagrationPlace: "Vellore", inagrationItem: "milk" },
];

const Franchise = () => {
  const [view, setView] = useState(null);
  const [activeTab, setActiveTab] = useState(0);
  const [menuOpen, setMenuOpen] = useState(false);
  const [assigned, setAssigned] = useState("");
  const [currentImages, setCurrentImages] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [assignedDatas, setAssignedDatas] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [employees, setEmployees] = useState([]);
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(5);
  const [teams, setTeams] = useState([]);
  const [items, setItems] = useState([]);
  const navigate = useNavigate();

  const handleView = (id) => {
    setView(id);
  };

  const handleClose = () => {
    setView(null);
  };

  const handleOpen = (id) => {
    setMenuOpen(menuOpen === id ? false : id);
    setAssigned(id);
  };
  const handlecloseMenu = () => {
    setMenuOpen(null);
  };

  const handleSelectChange = (teamId, employeeId) => {
    setAssignedDatas((prev) => {
      const exists = prev.find((item) => item.team === teamId);

      if (exists) {
        // update existing
        return prev.map((item) =>
          item.team === teamId ? { ...item, employee: employeeId } : item
        );
      }

      // add new
      return [...prev, { team: teamId, employee: employeeId }];
    });
  };

  const handleAssign = async () => {
    try {
      // ✅ Validation: all teams must have employees
      if (assignedDatas.length !== teams.length) {
        alert("Please assign employees to all teams before proceeding.");
        return;
      }

      // Optional: extra safety check
      const allFilled = teams.every((team) =>
        assignedDatas.some((item) => item.team === team._id && item.employee)
      );

      if (!allFilled) {
        alert("Please assign employees to all teams before proceeding.");
        return;
      }

      // ✅ API call
      await assignToEmployees(assigned, assignedDatas);

      alert("All employees assigned successfully!");
      setMenuOpen(null);
    } catch (error) {
      console.error("Assignment failed:", error);
      alert("Failed to assign employees. Please try again.");
    }
  };

  const openSlideshow = (images, index) => {
    setCurrentImages(images);
    setCurrentIndex(index);
    setIsModalOpen(true);
  };

  const closeSlideshow = () => {
    setIsModalOpen(false);
  };

  const goPrev = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? currentImages.length - 1 : prevIndex - 1
    );
  };

  const goNext = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === currentImages.length - 1 ? 0 : prevIndex + 1
    );
  };

  const percentage = 80;

  useEffect(() => {
    const fetchApprovedLeads = async () => {
      try {
        const res = await getAllFranchise();
        if (res?.data) {
          const approved = res.data;
          setItems(approved);
        }
      } catch (err) {
        console.error("Failed to fetch leads:", err);
      } finally {
        setLoading(false);
      }
    };

    const fetchEmployees = async () => {
      try {
        const res = await getAllEmployee();
        const resTeam = await getAllTeam();
        setTeams(resTeam.data);
        if (res?.data) {
          const approved = res.data;
          setEmployees(approved);
        }
      } catch (err) {
        console.error("Failed to fetch leads:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchEmployees();
    fetchApprovedLeads();
  }, []);

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = items.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(items.length / itemsPerPage);

  return (
    <div>
      <div className=" flex items-center justify-between w-full">
        <h1 className="text-2xl md:text-2xl font-semibold mb-4 md:mb-0">
          Franchise
        </h1>
        <div className="relative md:w-64 w-full max-w-xs mt-3">
          <input
            type="text"
            placeholder="Search ..."
            className="w-full py-2 pl-3 pr-10 text-sm border rounded-lg poppins-medium 
                           focus:outline-none focus:ring-1 focus:ring-red-400"
          />
          <FaSearch className="absolute right-3 top-1/2 -translate-y-1/2 text-red-500" />
        </div>
      </div>
      <div className="md:block hidden">
        <table className="min-w-full mt-4 bg-white border">
          <thead className="bg-red-600 text-white">
            <tr>
              <th className="px-2 py-3 border-b-2 border-gray-300 text-left text-xs uppercase cursor-pointer">
                S.No
              </th>
              <th className="px-2 py-3 border-b-2 border-gray-300 text-left text-xs uppercase cursor-pointer">
                Franchise Name
              </th>

              <th className="px-2 py-3 border-b-2 border-gray-300 text-left text-xs uppercase cursor-pointer">
                Enquiry Date
              </th>
              <th className="px-2 py-3 border-b-2 border-gray-300 text-left text-xs uppercase cursor-pointer">
                Address
              </th>
              <th className="px-2 py-3 border-b-2 border-gray-300 text-left text-xs uppercase cursor-pointer">
                Leads Date
              </th>
              <th className="px-2 py-3 border-b-2 border-gray-300 text-left text-xs uppercase cursor-pointer">
                Source
              </th>
              <th className="px-2 py-3 border-b-2 border-gray-300 text-left text-xs uppercase cursor-pointer">
                Photo
              </th>

              <th className="px-2 py-3 border-b-2 border-gray-300 text-left text-xs uppercase cursor-pointer">
                Payment
              </th>
              {/* 
                   <th className="px-2 py-3 border-b-2 border-gray-300 text-left text-xs uppercase cursor-pointer">
                    Status
                  </th> */}

              <th className="px-2 py-3 border-b-2 border-gray-300 text-left text-xs uppercase cursor-pointer">
                Action
              </th>
            </tr>
          </thead>
          <tbody>
            {currentItems.length > 0 ? (
              currentItems.map((item, index) => (
                <tr key={index} className="hover:bg-gray-100">
                  <td className="px-2 py-4 border-b border-gray-200 text-xs">
                    {index + 1}
                  </td>

                  <td className="px-2 py-4 border-b border-gray-200 text-xs">
                    <span className=" font-medium block">{item.franchiseName}</span>
                    
                    {item.name}
                    <br />
                    {item.phone}
                  </td>

                  <td className="px-2 py-4 border-b border-gray-200 text-xs">
                    {new Date(item.enquiryDate).toLocaleDateString("en-GB")}
                  </td>
                  <td className="px-2 py-4 border-b border-gray-200 text-xs md:text-sm">
                    {item.address}
                    {/* <p>
                          <a
                            className="exlink"
                            target="_blank"
                            href="https://maps.app.goo.gl/SjUj1YAaDicasMaQ7"
                          >
                            Location
                          </a>
                        </p> */}
                  </td>
                  <td className="px-2 py-4 border-b border-gray-200 text-xs">
                    {new Date(item.lead?.createdAt).toLocaleDateString("en-GB")}
                  </td>
                  <td className="px-2 py-4 border-b border-gray-200 text-xs">
                    {item.source}
                  </td>
                  <td className="px-2 py-4 md:text-sm cursor-pointer border-b border-gray-200 text-xs">
                    {item.medias?.length > 0 && (
                      <p>
                        <span
                          className="exlink"
                          target="_blank"
                          onClick={(e) => {
                            openSlideshow(item.medias, 0);
                          }}
                        >
                          Media
                        </span>
                      </p>
                    )}
                  </td>

                  <td className="px-2 py-4 border-b border-gray-200 text-right font-medium text-sm">
                    <span className="">{item.totalPayment}</span> <br />
                    <span className=" text-green-700">{item.initPayment}</span>
                  </td>

                  <td>
                    {item.assign.length ? (
                      <button
                        className="rounded-md px-4 py-2 font-bold"
                        onClick={() => navigate(`/franchise/${item._id}`)}
                      >
                        <IoEyeOutline fontSize={18} />
                      </button>
                    ) : (
                      <button
                        className="px-2 py-4 border-b border-gray-200 text-xs"
                        onClick={() => handleOpen(item._id)}
                      >
                        <FaArrowRight fontSize={15} />
                      </button>
                    )}
                  </td>
                  <>
                    {isModalOpen && currentImages.length > 0 && (
                      <div className="fixed inset-0 flex justify-center items-center bg-black bg-opacity-25 z-50">
                        <div className="relative bg-white p-4 rounded-lg shadow-lg w-[450px] h-auto flex flex-col items-center">
                          {/* Close Button */}
                          <button
                            className="absolute top-2 right-2 text-red-600 text-xl font-bold"
                            onClick={closeSlideshow}
                          >
                            <ImCross size={20} />
                          </button>

                          {/* Main Image */}
                          <div className="flex justify-center mt-8">
                            <img
                              src={currentImages[currentIndex]}
                              alt="Slideshow"
                              className="w-[300px] h-[300px] rounded-lg object-cover"
                            />
                          </div>

                          <div className="flex justify-between w-full px-6 mt-4">
                            <button
                              className="bg-gray-800 text-white px-4 py-2 rounded-md"
                              onClick={goPrev}
                            >
                              ◀
                            </button>
                            <button
                              className="bg-gray-800 text-white px-4 py-2 rounded-md"
                              onClick={goNext}
                            >
                              ▶
                            </button>
                          </div>

                          <p className="text-center text-sm text-gray-600 mt-2">
                            {currentIndex + 1} / {currentImages.length}
                          </p>

                          {Array.isArray(currentImages) &&
                            currentImages.length > 0 && (
                              <div className="mt-4 flex flex-wrap gap-2 justify-center">
                                {currentImages.map((preview, index) => (
                                  <img
                                    key={index}
                                    src={preview}
                                    alt={`Preview ${index}`}
                                    className={`w-16 h-16 object-cover rounded-md border cursor-pointer 
                               ${
                                 index === currentIndex
                                   ? "border-4 border-blue-500"
                                   : "border-gray-300"
                               }`}
                                    onClick={() => setCurrentIndex(index)}
                                  />
                                ))}
                              </div>
                            )}
                        </div>
                      </div>
                    )}
                  </>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="11" className="text-center py-4 text-gray-500">
                  No enquiries found
                </td>
              </tr>
            )}
          </tbody>
        </table>

        <div className="flex justify-center mt-4 space-x-2">
          <button
            className="px-3 py-1 border rounded disabled:opacity-50"
            onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
            disabled={currentPage === 1}
          >
            <MdArrowLeft />
          </button>

          {[...Array(totalPages)].map((_, i) => (
            <button
              key={i}
              className={`px-3 py-1 border rounded ${
                currentPage === i + 1 ? "bg-red-600 text-white" : ""
              }`}
              onClick={() => setCurrentPage(i + 1)}
            >
              {i + 1}
            </button>
          ))}

          <button
            className="px-3 py-1 border rounded disabled:opacity-50"
            onClick={() =>
              setCurrentPage((prev) => Math.min(prev + 1, totalPages))
            }
            disabled={currentPage === totalPages}
          >
            <MdArrowRight />
          </button>
        </div>
      </div>
      {menuOpen && (
        <div className="fixed inset-0 z-50 flex bg-opacity-50">
          {/* Drawer */}
          <div className="ml-auto w-full max-w-md bg-white h-full shadow-xl flex flex-col">
            {/* Header */}
            <div className="flex items-center gap-3 px-4 py-3 border-b">
              <button
                onClick={handlecloseMenu}
                className="flex items-center gap-1 text-gray-600 hover:text-red-600"
              >
                <MdArrowBack size={18} />
                <span className="text-sm font-semibold">Back</span>
              </button>
              <h2 className="text-base font-bold text-gray-800 ml-auto">
                Assign Employees
              </h2>
            </div>

            {/* Body */}
            <div className="flex-1 overflow-y-auto px-4 py-4 space-y-4">
              {teams.map((step, index) => (
                <div
                  key={index}
                  className="border rounded-lg p-4 shadow-sm hover:shadow-md transition"
                >
                  <div className="flex items-center justify-between mb-3">
                    <div className="flex items-center gap-3">
                      <span className="w-8 h-8 flex items-center justify-center rounded-full bg-red-600 text-white text-sm font-bold">
                        {index + 1}
                      </span>
                      <h3 className="font-semibold text-gray-800">
                        {step.name}
                      </h3>
                    </div>
                  </div>

                  {/* Employee Select */}
                  <select
                    className="w-full border border-gray-300 rounded-md p-2 text-sm
                         focus:outline-none focus:ring-2 focus:ring-red-500"
                    value={assignedDatas[index]?.employee || ""}
                    onChange={(e) =>
                      handleSelectChange(step._id, e.target.value)
                    }
                  >
                    <option value="">Select Employee</option>
                    {employees.map((emp) => (
                      <option key={emp._id} value={emp._id}>
                        {emp.name}
                      </option>
                    ))}
                  </select>
                </div>
              ))}
            </div>

            {/* Footer */}
            <div className="border-t px-4 py-3 bg-white">
              <button
                onClick={handleAssign}
                className="w-full bg-red-600 hover:bg-red-700 text-white
                     py-2 rounded-md font-semibold transition"
              >
                Assign Employees
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Franchise;
